import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=6617621d&scoped=true"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"
import style0 from "./MainNav.vue?vue&type=style&index=0&id=6617621d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6617621d",
  null
  
)

export default component.exports